import React, { FC } from 'react';
import { EntityType } from 'common/enums';
import {
    CHECKBOX_HIERARCHY_OFFSET_CATEGORY,
    CHECKBOX_HIERARCHY_OFFSET_SUBCATEGORY,
    CHECKBOX_HIERARCHY_OFFSET_INDICATOR
} from 'common/config';

import './CheckboxCellRenderer.scss';
import Icon from 'common/components/base/icon';
import { ICON_COLLECTION } from 'assets/media/icons';
import Checkbox from 'common/components/base/checkbox';

type CheckboxCellRendererProps = {
    value: string;
    data: any;
    onlyIndicator: boolean;
    onExpansionToggle: (data: any) => void;
    onClickCheckbox: (isSelected: boolean, value: any) => void;
};

const CheckboxCellRenderer: FC<CheckboxCellRendererProps> = ({
    value,
    data,
    onlyIndicator,
    onExpansionToggle,
    onClickCheckbox
}: CheckboxCellRendererProps) => {
    const cellStyles = {
        marginLeft: `${
            data.level === 0
                ? CHECKBOX_HIERARCHY_OFFSET_CATEGORY
                : data.entityType === EntityType.Indicator
                ? data.level * CHECKBOX_HIERARCHY_OFFSET_INDICATOR - 10
                : data.level * CHECKBOX_HIERARCHY_OFFSET_SUBCATEGORY
        }px`
    };
    const expansionIndicationClass =
        data.isParentExpanded || data.isExpanded ? 'checkbox-cell-cell-expanded' : '';

    const nameValueClass = `name-value ${
        data.isExpanded
            ? 'name-value-expanded'
            : data.entityType === EntityType.Indicator
            ? 'name-value-light'
            : ''
    }`;

    return (
        <div className={`checkbox-cell ${expansionIndicationClass}`} title={value}>
            {onlyIndicator && data.entityType == EntityType.Indicator ? (
                <Checkbox
                    id={`mapToVariantCheckbox${data.entityType + data.id}`}
                    checked={data?.isSelected}
                    disabled={false}
                    name={`mapToVariantCheckbox${data.entityType + data.id}`}
                    value={value}
                    onChange={(event) => {
                        onClickCheckbox(event.target.checked, data);
                    }}
                    className="checkbox-cell__checkbox"
                />
            ) : !onlyIndicator ? (
                <Checkbox
                    id={`mapToVariantCheckbox${data.entityType + data.id}`}
                    checked={data?.isSelected}
                    disabled={false}
                    name={`mapToVariantCheckbox${data.entityType + data.id}`}
                    value={value}
                    onChange={(event) => {
                        onClickCheckbox(event.target.checked, data);
                    }}
                    className="checkbox-cell__checkbox"
                />
            ) : (
                <div style={{ width: '3rem' }}></div>
            )}

            <div className="checkbox-cell-contents" style={cellStyles}>
                {data.hasChild ? (
                    data.entityType !== EntityType.Indicator &&
                    (data.isExpanded ? (
                        <Icon
                            className="name-icon name-icon-expanded"
                            src={ICON_COLLECTION.IC_ExpandMore}
                            onClick={() => onExpansionToggle(data)}
                        />
                    ) : (
                        <Icon
                            className="name-icon"
                            src={ICON_COLLECTION.IC_ChevronRight}
                            onClick={() => onExpansionToggle(data)}
                        />
                    ))
                ) : (
                    <span className="name-icon empty" />
                )}

                <span className={nameValueClass}>{value}</span>
            </div>
        </div>
    );
};
export default CheckboxCellRenderer;
